import type { BrushDefinition } from "./brushTypes";

export const pencilBrush: BrushDefinition = {
  tool: "pencil",
  label: "Pencil",
  widthMultiplier: 1,
  baseOpacity: 0.98,
  interpolationSpacing: 0.22,
  pressureSensitive: true,
  texture: "solid",
};
